/* ELTAYEB · Category Shelf
   - edge fade hint: shown on every device while more cards remain
   - arrow buttons: fine pointers only (touch users swipe)
   This script only ever ADDS affordances. It never hides product cards. */
(() => {
  if (window.__etsShelfReady) return;
  window.__etsShelfReady = true;

  const BOUND = new WeakSet();

  const setup = (rail) => {
    if (BOUND.has(rail)) return;
    BOUND.add(rail);

    const sec  = rail.closest('.ets');
    const wrap = rail.closest('[data-ets-wrap]');
    const nav  = sec && sec.querySelector('[data-ets-nav]');
    const rtl  = getComputedStyle(rail).direction === 'rtl';

    const scrollable = () => rail.scrollWidth > rail.clientWidth + 4;

    let prev = null, next = null;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (nav && finePointer) {
      prev = nav.querySelector('[data-ets-prev]');
      next = nav.querySelector('[data-ets-next]');

      // scrollBy() is normalised across engines, but the visual "next"
      // direction flips in RTL, so flip the sign.
      const go = (forward) => {
        const amount = Math.round(rail.clientWidth * 0.82) * (forward ? 1 : -1) * (rtl ? -1 : 1);
        rail.scrollBy({ left: amount, behavior: 'smooth' });
      };
      next.addEventListener('click', () => go(true));
      prev.addEventListener('click', () => go(false));
    }

    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const pos = Math.abs(rail.scrollLeft);
      const more = scrollable() && pos < max - 2;

      if (wrap) wrap.dataset.more = more ? '1' : '0';

      if (nav) {
        if (finePointer && scrollable()) {
          nav.hidden = false;
          if (prev) prev.disabled = pos <= 2;
          if (next) next.disabled = pos >= max - 2;
        } else {
          nav.hidden = true;
        }
      }
    };

    rail.addEventListener('scroll', sync, { passive: true });
    new ResizeObserver(sync).observe(rail);
    sync();
  };

  const init = (root) => {
    (root || document).querySelectorAll('[data-ets-rail]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
